export const signalCategories = {
    PAGE: 'page',
    COMPONENT: 'component',
    AREA: 'area',
    API: 'api',
    GRAPHQL: 'graphql',
    SESSION: 'session',
    UNKNOWN: 'unknown'
};
